import { render, staticRenderFns } from "./ReturnConfirmation.vue?vue&type=template&id=82509f1a&scoped=true&"
import script from "./ReturnConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReturnConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReturnConfirmation.vue?vue&type=style&index=0&id=82509f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82509f1a",
  null
  
)

export default component.exports